import React, { useEffect, useState } from "react";

let adCheckTimeout;
let adsLoadedCount = 0;
let redirectTimeout;

const MainModule = () => {
    const [bgImage, setBgImage] = useState("");
    const [forceRedirect, setForceRedirect] = useState(false);
    const [shouldRedirectOnClick, setShouldRedirectOnClick] = useState(false);

    useEffect(() => {
        const randomNum = Math.floor(Math.random() * 8) + 1;
        setBgImage(`/img/${randomNum}-mini.png`);

        // Enable forceRedirect after 17s
        adCheckTimeout = setTimeout(() => {
            setForceRedirect(true);
        }, 7000);

        // Check if Layer 2 ads (d2, d3, d4) loaded after 7 seconds
        redirectTimeout = setTimeout(() => {
            // If none of the Layer 2 ads loaded, enable redirect on click
            if (adsLoadedCount === 0) {
                setShouldRedirectOnClick(true);
            }
        }, 7000);

        return () => {
            clearTimeout(adCheckTimeout);
            clearTimeout(redirectTimeout);
        };
    }, []);

    const handleAdLoad = () => {
        adsLoadedCount += 1;
    };

    const handleOverlayClick = () => {
        window.location.href = "https://picpromptify.com/";
    };

    const handlePageClick = () => {
        if (shouldRedirectOnClick) {
            window.location.href = "https://picpromptify.com/";
        }
    };

    return (
        <div className="relative w-full min-h-screen overflow-auto ">

            {/* LAYER 1 - Top Scrollable Layer (Transparent - clicks pass through) */}
            <div className="relative z-20 pointer-events-none bg-black">

                {/* SVG Section - Below d1 ad in Layer 1 */}
                <div className="w-full flex items-center justify-center py-8">
                    {bgImage && (
                        <img
                            src={bgImage}
                            alt="SVG Content"
                            className="max-w-md w-full h-auto"
                        />
                    )}
                </div>

                {/* Content Wrapper - Financial Services Content */}
                <div className="w-full max-w-4xl mx-auto px-4 py-8 text-white space-y-8">
                    <div className="space-y-8">
                        {/* Personal Loan */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-blue-400">1. Personal Loan</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Unlock Low-Interest Personal Loans for Debt Consolidation Today
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-blue-400 mt-1">•</span>
                                    <span>Secure fast personal loan approval with competitive rates.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Business Loan */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-emerald-400">2. Business Loan</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Fuel Your Growth with Small Business Loans and SBA Financing
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-emerald-400 mt-1">•</span>
                                    <span>Apply for SBA loans to expand your startup with low rates.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Car Loan */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-purple-400">3. Car Loan</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Drive Away with Affordable Auto Loans and Car Financing Rates
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-purple-400 mt-1">•</span>
                                    <span>Find the best auto loan refinance options to lower your car payment.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Insurance */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-orange-400">4. Insurance</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Protect Your Future with Comprehensive Insurance Quotes Online
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-orange-400 mt-1">•</span>
                                    <span>Get instant car insurance quotes from leading providers.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Home Loan */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-pink-400">5. Home Loan</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Achieve Homeownership with Mortgage Loans and Refinance Rates
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-pink-400 mt-1">•</span>
                                    <span>Explore FHA home loans for first-time buyers with low down payments.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Hospital */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-red-400">6. Hospital</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Access Medical Loans for Hospital Bills and Healthcare Financing
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-red-400 mt-1">•</span>
                                    <span>Secure emergency medical loans to cover hospital expenses.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Trading */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-cyan-400">7. Trading</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Master Stock Trading with Online Brokerage Accounts
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-cyan-400 mt-1">•</span>
                                    <span>Open a commission-free stock trading account to invest in ETFs.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Real Estate */}
                        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                            <h3 className="text-2xl font-bold mb-3 text-yellow-400">8. Real Estate</h3>
                            <h4 className="text-xl font-semibold mb-4 text-white">
                                Invest in Real Estate with Property Loans and Rental Income Strategies
                            </h4>
                            <ul className="space-y-2 text-gray-200">
                                <li className="flex items-start gap-2">
                                    <span className="text-yellow-400 mt-1">•</span>
                                    <span>Secure real estate investment loans for flipping houses.</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Transparent overlay after 17 seconds */}
            {forceRedirect && (
                <div
                    className="fixed inset-0 z-[9999] cursor-pointer"
                    onClick={handleOverlayClick}
                />
            )}
        </div>
    );
};

export default MainModule;